import type { SynastryShareResponse, SynastryV2Response } from '@/api/schema/synastry'
import { Input } from '@/app/components/Input/Input'
import { Motion } from '@/app/components/Motion/Motion'
import { Lib } from '@/app/components/UI/Lib'
import { UI } from '@/app/components/UI/UI'
import { useClipboard } from '@/app/hooks/useClipboard'
import CopyCheckSvg from '@/app/icons/copy-check.svg?react'
import CopySvg from '@/app/icons/copy.svg?react'
import { api } from '@/app/utils/api'
import type { FunctionalComponent } from 'preact'
import { useLayoutEffect, useState } from 'preact/hooks'
import styles from './index.module.scss'

export const Share: FunctionalComponent<{
  data: SynastryV2Response
  onClose: () => void
}> = props => {
  const [shareId, setShareId] = useState<string | null>(null)
  const clipboard = useClipboard()

  const shareUrl = shareId ? `https://zoeastro.ru/syn/${shareId}` : null
  const canShare = typeof navigator !== 'undefined' && !!navigator.share

  const handleShare = async () => {
    if (!shareUrl) return

    try {
      if (navigator.share) {
        await navigator.share({
          text: `${props.data.persone1Name} 💖 ${props.data.persone2Name} — разбор совместимости на Zoe Astro: ${shareUrl}`,
        })

        return
      }

      clipboard.copy(shareUrl)
    }
    catch {
      // cancel share dialog — можно игнорировать
    }
  }

  useLayoutEffect(() => {
    if (!props.data.shareId) {
      api.post<SynastryShareResponse>(`/synastry/${props.data.id}/share`)
        .then(r => {
          setShareId(r.data.shareId)
        })
    }
    else {
      setShareId(props.data.shareId)
    }
  }, [props.data.shareId])

  return (
    <UI.Popup
      onClose={props.onClose}
    >
      <Lib.PopupHeader>
        А что {props.data.persone2Gender === 'female' ? 'она' : 'он'} скажет?
      </Lib.PopupHeader>

      <Lib.PopupMessage>
        Разбор доступен по ссылке
      </Lib.PopupMessage>

      <Input
        readOnly
        value={shareId ? `https://zoeastro.ru/syn/${shareId}` : ''}
        onClick={() => {
          if (!shareUrl) return
          clipboard.copy(shareUrl)
        }}
        rightBtn={shareId && (
          clipboard.copied
            ? (
              <Motion initialX={0} class={styles.copy}>
                <CopyCheckSvg width={16} height={16} strokeWidth={2} />
              </Motion>
            )
            : (
              <button
                type='button'
                class={styles.copy}
              >
                <CopySvg width={16} height={16} strokeWidth={2} />
              </button>
            )
        )}
      />

      {canShare
        ? (
          <UI.Button
            size='l'
            type='primary'
            onClick={handleShare}
            disabled={!shareId}
          >
            Отправить ссылку
          </UI.Button>
        )
        : (
          <UI.Button
            size='l'
            type='primary'
            onClick={handleShare}
            disabled={!shareId || clipboard.copied}
          >
            {clipboard.copied ? 'Ссылка скопирована' : 'Скопировать'}
          </UI.Button>
        )}
    </UI.Popup>
  )
}
